import React from "react"
import Section from "./section"
import { css } from "@emotion/core"

const Clients = () => {
  return (
    <Section Id="quienes-somos" title="Quienes somos">
      <div
        className="row"
        css={css`
          margin-bottom: 40px;
          font-size: 22px;
        `}
      >
        <p>
          Somos una empresa dedicada a cuidar a nuestros clientes brindándoles una experiencia de conformidad y excelentes resultados.
        </p>

        <p>
          Trabajamos en forma ordenada y prolija respetando los tiempos del cliente, contamos con un sistema de clientes donde usted puede recibir grandes descuentos en la reparación de dos o más equipos, nuestros precios son  accesibles y compiten con el estándar, nuestro servicio es personalizado y de calidad.
        </p>
      </div>
    </Section>
  )
}

export default Clients
